//requires: public\Modal.js

/**
 * 
 */


L.EnhancedContent = L.Evented.extend({
	
	initialize: function(source, options){
		this._source = source;
		L.Util.setOptions(this, options); 

	},
	


})

L.EnhancedContent.None = L.EnhancedContent.extend({
	
	statics: {
		TYPE: "none"
	},
	
	getType: function(){
		return  L.EnhancedContent.None.TYPE;
	},
	
	getProperties(){
		return {};
	},
	
	display: function(){		
	},
	
	toJSONable: function(){
		var jsonable= {};
		
		jsonable['type'] = this.getType();
		return jsonable;
	}

})

L.EnhancedContent.none = function (source, options) {
    return new L.EnhancedContent.None( options);
};


L.Popup.include({
	bindEnhancedContent: function(content){
		if (content instanceof L.EnhancedContent){
			this._enhancedContent = content;
			content._source = this;
			if (content.getType() != 'none'){
				content._source._source.on('preclick',content.onCustomContentUpdate,content._source);
			}
		}
	},
	
	onCustomContentUpdate: function(e){
		
		this._content = this.formatCustomContent();
		if (this._source.setContent){
			
			this._source.setContent(this._content);
		}
	},
	
	unbindEnhancedContent: function(){
		
		this._enhancedContent._source = undefined;
		var unBinded = this._enhancedContent;
		this._enhancedContent = undefined;
		return unBinded;
	},
	
	setEnhancedContent: function(){
		if (this._enhancedContent){
			this._enhancedContent.display();
		}	
	},
	
	getEnhancedContent: function(){
		return  this._enhancedContent;
	}
})

L.Modal.include({
	bindEnhancedContent: function(content){
		if (content instanceof L.EnhancedContent){
			this._enhancedContent = content;
			content._source = this;
			if (content.getType() != 'none'){
				content._source._source.on('preclick',content.onContentUpdate,content);
			}
		}
	},
	
	unbindEnhancedContent: function(){
		
		this._enhancedContent._source = undefined;
		var unBinded = this._enhancedContent;
		this._enhancedContent = undefined;
		return unBinded;
	},
	
	displayEnhancedContent: function(){
		if (this._enhancedContent){
			this._enhancedContent.display();
		}	
	},
	
	getEnhancedContent: function(){
		return  this._enhancedContent;
	}
})

L.Tooltip.include({
	bindEnhancedContent: function(content){
		if (content instanceof L.EnhancedContent){
			this._enhancedContent = content;
			content._source = this;
			if (content.getType() != 'none'){
				content._source.on('tooltipopen',content.onContentUpdate,content);
			}
		}
	},
	
	unbindEnhancedContent: function(){
		
		this._enhancedContent._source = undefined;
		var unBinded = this._enhancedContent;
		this._enhancedContent = undefined;
		return unBinded;
	},
	
	displayEnhancedContent: function(){
		if (this._enhancedContent){
			this._enhancedContent.display();
		}	
	},
	
	getEnhancedContent: function(){
		return  this._enhancedContent;
	}
})


L.enhancedContent = function (type, source, options) {
	
	var source = source || null;
	var options = options || null;	
	
	switch (type) {
	case L.EnhancedContent.Custom.TYPE:
		return L.EnhancedContent.custom(source,options);
		break;
		
	case L.EnhancedContent.Linked.TYPE:
		return L.EnhancedContent.linked(source,options);
		break;
		
//	case L.EnhancedContent.External.TYPE:
//		return L.EnhancedContent.external(source,options);
//		break;
//		
	case L.EnhancedContent.None.TYPE:
		return L.EnhancedContent.none(source,options);
		break;
		
	default:
		return null;
		break;
	}
	
	
    
};